import { apiClient } from '../../../gateways/api'
import type { AdditioneleVraagResponse } from '../types/AdditioneleVraag'

export { fetchKlantAdditioneleVragen }

const fetchKlantAdditioneleVragen = async ({
  id,
}: {
  id: string
}): Promise<AdditioneleVraagResponse[]> => {
  const { data } = await apiClient({
    url: `/rest/project/${id}/additionelevragen`,
    method: 'GET',
  })

  return data
}
